import React from 'react';
import styled from 'styled-components'

const ContentContainer = styled.div`
    margin: 20px;
`;

const TranscriptionContainerMobile = styled.div`
    height: calc(80vh - 200px);
    overflow-y: auto;

    @media only screen and (min-width: 1200px) {
        display: none
    }
`;

const TranscriptionContainerDesktop = styled.div`
    height: calc(85vh - 200px);
    overflow-y: auto;

    @media only screen and (max-width: 1200px) {
        display: none
    }
`;

const ButtonClose = styled.p`
    border-bottom: 2px solid #343434;
    font-size: 10px;
    padding-bottom: 10px;

    @media only screen and (min-width: 1200px) {
        display: none;
    }
`;

const TranscriptionRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
`;

const TranscriptionTextContainer = styled.div`
    width: 48%;
`;

const ContentTranscription = ({ contentFiltered, setShowEng, showEng }) => {
    // تبدیل متن‌ها به آرایه‌ای از بلوک‌ها
    const maoriBlocks = React.Children.toArray(contentFiltered.transcript_maori.props.children);
    const engBlocks = React.Children.toArray(contentFiltered.transcript_eng.props.children);

    return (
        <ContentContainer>
            {/* <p>#	Kupu Mino / Borrowed words	=	Kupu Taurite / Synonyms	>	Whakamārama / Explanations, Translations</p> */}
            <ButtonClose onClick={() => setShowEng(!showEng)}>
                {!showEng ? "Explore the english translation" : "Back to Māori original"}
            </ButtonClose>
            <TranscriptionContainerMobile>
                {!showEng ? contentFiltered.transcript_maori : contentFiltered.transcript_eng}
            </TranscriptionContainerMobile>
            <TranscriptionContainerDesktop>
                {maoriBlocks.map((maoriBlock, index) => (
                    <TranscriptionRow key={index}>
                        <TranscriptionTextContainer>
                            {maoriBlock}
                        </TranscriptionTextContainer>
                        <TranscriptionTextContainer>
                            {engBlocks[index]}
                        </TranscriptionTextContainer>
                    </TranscriptionRow>
                ))}
            </TranscriptionContainerDesktop>
        </ContentContainer>
    )
}

export default ContentTranscription;